import { Box, ListItem, ListItemText, styled } from "@mui/material"

export const StyledListItem = styled(ListItem)({
  borderRadius: "0 !important",
  padding: "14px 0",
  alignItems: "flex-start !important",
  display: "flex",
  flexDirection: "column"
})

export const StyledBoxFullWidth = styled(Box)({
  width: "100%",
  display: "flex"
})

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  fontSize: "16px",
  color: theme.palette.foreground.default,
  fontWeight: "600",
  ".MuiListItemText-primary": {
    fontWeight: "600"
  }
}))
